import { useQuery } from '@tanstack/react-query';

import { getPharmacistBatchDispenseOrders } from '@/services/pharmacist.service';

const useGetPharmacistBatchDispense = ({
  pageSize,
  page,
  isEnabled,
}: {
  pageSize: number;
  page: number;
  isEnabled: boolean;
}) => {
  const { isLoading, data, isError, isSuccess, refetch } = useQuery({
    queryKey: ['getPharmacistBatchDispense'],
    enabled: isEnabled,
    queryFn: async () => await getPharmacistBatchDispenseOrders(pageSize, page),
  });

  return { isLoading, data, isError, isSuccess, refetch };
};

export default useGetPharmacistBatchDispense;
